{
  "addSupplier": {
    "stepper": {
      "title": "Lieferanten hinzufügen",
      "steps": {
        "generalInfo": {
          "title": "Allgemeine Info",
          "description": "Allgemeine Lieferanteninformationen eingeben"
        },
        "riskAssessment": {
          "title": "Risikobewertung",
          "description": "Risikostufe des Lieferanten auswählen"
        },
        "supportingDocuments": {
          "title": "Unterstützende Dokumente",
          "description": "Erforderliche Dokumentation hochladen oder verknüpfen"
        },
        "approval": {
          "title": "Freigabe",
          "description": "Alle Informationen prüfen und den Lieferanten zur Freigabe senden"
        }
      },
      "buttons": {
        "saveAsDraft": "Als Entwurf speichern und schließen",
        "cancel": "Abbrechen",
        "previous": "Zurück",
        "next": "Weiter",
        "sendForApproval": "Zur Freigabe senden"
      }
    },
    "generalInfo": {
      "heading": "Allgemeine Info",
      "fields": {
        "supplierName": {
          "label": "Lieferantenname*",
          "helper": "Dieses Feld ist erforderlich, wenn zur Freigabe gesendet wird."
        },
        "supplierType": {
          "label": "Lieferantentyp",
          "helper": "Dieses Feld ist erforderlich, wenn zur Freigabe gesendet wird."
        },
        "website": {
          "label": "Website"
        },
        "intendedUse": {
          "label": "Verwendungszweck"
        },
        "sponsor": {
          "label": "Sponsor",
          "helper": "Dieses Feld ist erforderlich, wenn zur Freigabe gesendet wird."
        }
      },
      "contactInfo": {
        "heading": "Kontaktinformationen des Lieferanten",
        "fields": {
          "name": "Name",
          "email": "E-Mail",
          "phone": "Telefon",
          "address": "Adresse",
          "notes": "Notizen"
        }
      },
      "warnings": {
        "invalidFields": "Einige Felder enthalten scheinbar ungültige Werte."
      }
    },
    "riskAssessment": {
      "heading": "Risikobewertung",
      "description": "Risikostufen werden durch die Lieferantenrichtlinie definiert. Wenn Sie unsicher sind, können Sie dies später nachholen. Beachten Sie, dass die Risikostufe erforderlich ist, um die gemäß Richtlinie notwendigen Dokumente zuzuweisen."
    },
    "supportingDocuments": {
      "heading": "Unterstützende Dokumente",
      "alerts": {
        "selectTypeAndRisk": "Wählen Sie Lieferantentyp und Risikostufe aus, um die erforderlichen Dokumente zu sehen.",
        "noMandatoryDocuments": "Ihre Lieferantenrichtlinie erfordert keine obligatorischen Dokumente für den Lieferantentyp {{type}} und die Risikostufe {{level}}.",
        "documentsMovedTitle": "Dokumente nach \"Zusätzliche Dokumente\" verschoben",
        "documentsMovedDescription": "Jede Risikostufe kann unterschiedliche Dokumente erfordern. Da die Risikostufe geändert wurde, wurden alle Dokumente nach \"Zusätzliche Dokumente\" verschoben. Um sie wiederzuverwenden, laden Sie sie herunter und fügen Sie sie den erforderlichen Dokumenten hinzu. Diese Änderungen werden wirksam, wenn Sie den Lieferanten speichern."
      },
      "policyText": "Ihre Lieferantenrichtlinie erfordert die folgenden Dokumente für den Lieferantentyp {{type}} und die Risikostufe {{level}}.",
      "additionalDocumentsInfo": "Fügen Sie zusätzliche Dokumentationen hinzu, die für diesen Lieferanten relevant sind."
    },
    "approval": {
      "heading": "Freigabe",
      "infoText": "Überprüfen Sie die Lieferanteninformationen, bevor Sie sie zur Freigabe senden.",
      "sections": {
        "generalInformation": "Allgemeine Informationen",
        "supplierContactInformation": "Kontaktinformationen des Lieferanten",
        "riskLevel": "Risikostufe",
        "supportingDocuments": "Unterstützende Dokumente",
        "additionalDocuments": "Zusätzliche Dokumente",
        "requiredAudits": "Erforderliche Audits",
        "approval": "Freigabe"
      },
      "fields": {
        "supplierName": "Lieferantenname",
        "supplierType": "Lieferantentyp",
        "website": "Website",
        "intendedUse": "Verwendungszweck",
        "sponsor": "Sponsor",
        "name": "Name",
        "email": "E-Mail",
        "phone": "Telefon",
        "address": "Adresse",
        "notes": "Notizen",
        "approvers": "Genehmigende Personen"
      },
      "messages": {
        "noMandatoryDocuments": "Es gibt keine obligatorischen Dokumente",
        "noAdditionalDocuments": "Es gibt keine zusätzlichen Dokumente",
        "requiredAuditsPolicy": "Für den Lieferantentyp {{type}} und die Risikostufe {{level}} erfordert Ihre Lieferantenrichtlinie diese Audits",
        "noRequiredAuditsPolicy": "Für den Lieferantentyp {{type}} und die Risikostufe {{level}} erfordert Ihre Lieferantenrichtlinie keine obligatorischen Audits",
        "auditFrequency": "Alle {{count}} Monat(e)",
        "auditOnce": "Nur einmal",
        "approvalInfo": "Wählen Sie Personen aus, die diesen Lieferanten freigeben können. Mindestens ein Quality-Benutzer muss ausgewählt werden. Nur Benutzer mit Zugriff auf Lieferanten können als Genehmiger ausgewählt werden. Die Freigabe erfolgt, wenn alle akzeptiert haben.",
        "auditReviewWarning": "Falls vor der Freigabe eine Überprüfung der Audits erforderlich ist, können Sie diesen Lieferanten speichern und das Audit sowie alle zugehörigen Dokumente im Abschnitt \"Audits\" dieses Lieferanten hinzufügen."
      },
      "warnings": {
        "requiredFieldsMissing": "Es scheinen Pflichtfelder zu fehlen oder einige Felder enthalten ungültige Werte."
      },
      "supplierPolicyLink": "Lieferantenrichtlinie"
    },
    "modals": {
      "discardChanges": {
        "title": "Änderungen verwerfen",
        "message": "Sind Sie sicher, dass Sie Ihre Änderungen an diesem Lieferanten verwerfen möchten? Sie können ihn auch als Entwurf speichern und später fertigstellen.",
        "buttons": {
          "cancel": "Abbrechen",
          "saveAsDraft": "Als Entwurf speichern",
          "discardChanges": "Änderungen verwerfen"
        }
      },
      "cantSaveSupplier": {
        "title": "Lieferant kann nicht gespeichert werden",
        "message": "Um diesen Lieferanten zu speichern, müssen Sie ihm einen Namen geben.",
        "button": "Verstanden"
      },
      "changeSupplierType": {
        "title": "Lieferantentyp ändern?",
        "message": "Jede Risikostufe kann unterschiedliche Dokumente erfordern. Alle Dokumente werden nach \"Zusätzliche Dokumente\" verschoben, wenn Sie den Lieferanten speichern.",
        "buttons": {
          "cancel": "Abbrechen",
          "change": "Lieferantentyp ändern"
        }
      },
      "changeRiskLevel": {
        "title": "Risikostufe ändern?",
        "message": "Jede Risikostufe kann unterschiedliche Dokumente erfordern. Alle Dokumente werden nach \"Zusätzliche Dokumente\" verschoben, wenn Sie den Lieferanten speichern.",
        "buttons": {
          "cancel": "Abbrechen",
          "change": "Risikostufe ändern"
        }
      }
    },
    "validation": {
      "errors": {
        "supplierNameRequired": "Bitte geben Sie einen Lieferantennamen ein",
        "supplierNameEmpty": "Lieferantenname darf nicht leer sein",
        "supplierNameTooLong": "Lieferantenname darf nicht länger als 350 Zeichen sein",
        "supplierTypeRequired": "Bitte wählen Sie einen Lieferantentyp aus",
        "intendedUseTooLong": "Das Feld Verwendungszweck darf nicht länger als 4000 Zeichen sein",
        "sponsorRequired": "Bitte wählen Sie einen Sponsor aus",
        "contactNotesTooLong": "Das Feld Kontaktnotizen darf nicht länger als 4500 Zeichen sein",
        "riskTypeRequired": "Bitte wählen Sie einen Risikotyp aus",
        "documentsRequired": "Mindestens 1 unterstützendes Dokument ist erforderlich für: {{documentNames}}",
        "approversRequired": "Genehmigende Personen müssen ausgewählt werden",
        "qualityUserRequired": "Die Genehmiger müssen mindestens einen Quality-Benutzer enthalten"
      },
      "fieldNames": {
        "name": "Name",
        "approvers": "Genehmigende Personen",
        "contactAddress": "Kontaktadresse",
        "contactEmail": "Kontakt-E-Mail",
        "contactName": "Kontaktname",
        "contactNotes": "Kontaktnotizen",
        "contactPhone": "Kontakttelefon",
        "documents": "Dokumente",
        "intendedUse": "Verwendungszweck",
        "riskType": "Risikotyp",
        "sponsor": "Sponsor",
        "supplierType": "Lieferantentyp",
        "website": "Website"
      }
    }
  },
  "supplierList": {
    "heading": "Lieferanten",
    "buttons": {
      "addSupplier": "Lieferanten hinzufügen",
      "import": "Importieren",
      "exportAsl": "ASL exportieren",
      "exportCurrentView": "Aktuelle Ansicht als CSV exportieren",
      "exportFullView": "Vollständige Ansicht als XLSX exportieren"
    },
    "search": {
      "placeholder": "Name suchen"
    },
    "filters": {
      "selectSupplierType": "Lieferantentyp wählen",
      "selectStatus": "Status wählen",
      "selectRiskType": "Risikotyp wählen",
      "showOnlyArchived": "Nur archivierte anzeigen"
    },
    "columns": {
      "name": "Name",
      "type": "Typ",
      "status": "Status",
      "risk": "Risiko",
      "sponsor": "Sponsor",
      "lastModified": "Zuletzt geändert",
      "lastAudit": "Letztes Audit",
      "dueIn": "Fällig in"
    },
    "emptyState": {
      "title": "Sie haben noch keine Lieferanten",
      "subtitle": "Bevor Sie einen Lieferanten hinzufügen, wird empfohlen, eine Lieferantenrichtlinie zu erstellen. Die Richtlinie definiert die Lieferantentypen, mit denen Sie arbeiten, Risikostufen zur Bewertung Ihrer Lieferanten und die erforderlichen Dokumententypen für eine Freigabe.",
      "buttons": {
        "addSupplier": "Lieferanten hinzufügen",
        "importSuppliers": "Lieferanten importieren",
        "configurePolicy": "Richtlinie konfigurieren"
      },
      "divider": "oder"
    },
    "errors": {
      "noApprovedSuppliers": "Keine freigegebenen Lieferanten zum Exportieren vorhanden",
      "cannotRetrievePolicyLinks": "Richtlinien-Links können nicht abgerufen werden"
    }
  },
  "supplierDetails": {
    "buttons": {
      "back": "Zurück",
      "edit": "Bearbeiten",
      "export": "Exportieren",
      "archive": "Archivieren",
      "unarchive": "Dearchivieren",
      "revertToDraft": "Zurück auf Entwurf setzen"
    },
    "tabs": {
      "details": "Details",
      "supportingDocuments": "Unterstützende Dokumente",
      "audits": "Audits"
    },
    "sections": {
      "riskLevel": "Risikostufe",
      "generalInfo": "Allgemeine Info",
      "supplierContactInformation": "Kontaktinformationen des Lieferanten"
    },
    "fields": {
      "supplierName": "Lieferantenname",
      "supplierType": "Lieferantentyp",
      "website": "Website",
      "intendedUse": "Verwendungszweck",
      "sponsor": "Sponsor",
      "approvers": "Genehmigende Personen",
      "createdOn": "Erstellt am",
      "lastModified": "Zuletzt geändert",
      "name": "Name",
      "email": "E-Mail",
      "phone": "Telefon",
      "address": "Adresse",
      "notes": "Notizen",
      "contactName": "Name",
      "contactEmail": "E-Mail",
      "contactPhone": "Telefon",
      "contactAddress": "Adresse",
      "contactNotes": "Notizen"
    },
    "modals": {
      "archive": {
        "title": "Archivieren",
        "message": "Sind Sie sicher, dass Sie diesen Lieferanten archivieren möchten? Sie können ihn jederzeit dearchivieren.",
        "button": "Archivieren"
      },
      "unarchive": {
        "title": "Dearchivieren",
        "message": "Sind Sie sicher, dass Sie diesen Lieferanten dearchivieren möchten? Der Status wird auf \"Entwurf\" geändert.",
        "button": "Dearchivieren"
      },
      "revertToDraft": {
        "title": "Auf Entwurf zurücksetzen",
        "message": "Möchten Sie diesen Lieferanten in den Status \"Entwurf\" zurückversetzen?",
        "button": "Zurücksetzen"
      },
      "export": {
        "title": "Lieferant exportieren",
        "message": "Der Lieferant wird als ZIP-Datei exportiert, die Folgendes enthält:\n- Eine PDF-Datei mit allen Lieferantendetails\n- Unterstützende Dokumente\n- Audit-Dateien",
        "button": "Lieferant exportieren"
      }
    }
  },
  "supplierDocuments": {
    "emptyState": {
      "title": "Dokumente für diesen Lieferanten erscheinen hier",
      "subtitle": "Wenn Ihre Lieferantenrichtlinie bestimmte Dokumente erfordert, bearbeiten Sie den Lieferanten, um sie hier hinzuzufügen."
    },
    "heading": "Zusätzliche Dokumente"
  },
  "supplierAudits": {
    "columns": {
      "name": "Name",
      "auditType": "Audit-Typ",
      "notes": "Notizen",
      "addedBy": "Hinzugefügt von",
      "dateCompleted": "Abschlussdatum",
      "dateAdded": "Hinzugefügt am",
      "documents": "Dokumente",
      "filesCount": "{{count}} Dateien"
    },
    "menu": {
      "viewDocuments": "Dokumente anzeigen",
      "edit": "Edit",
      "delete": "Löschen"
    },
    "emptyState": {
      "title": "Abgeschlossene Audits erscheinen hier",
      "subtitle": "Erfassen Sie das Ergebnis früherer Audits mit Abschlussdatum, zugehörigen Dateien und Notizen.",
      "button": "Audit hinzufügen"
    },
    "buttons": {
      "addAudit": "Audit hinzufügen"
    },
    "drawer": {
      "noDocuments": "Es sind keine Dokumente verfügbar."
    },
    "modals": {
      "deleteAudit": {
        "title": "Audit löschen",
        "message": "Sind Sie sicher, dass Sie dieses Audit löschen möchten?",
        "buttons": {
          "cancel": "Abbrechen",
          "delete": "Audit löschen"
        }
      },
      "addAudit": {
        "title": "Audit hinzufügen",
        "buttons": {
          "cancel": "Abbrechen",
          "add": "Audit hinzufügen"
        }
      },
      "editAudit": {
        "title": "Edit audit",
        "buttons": {
          "cancel": "Abbrechen",
          "save": "Save audit"
        }
      }
    },
    "nextAudit": {
      "dueTemplate": "Nächstes {{auditType}} Audit ist fällig in {{interval}}",
      "overdueTemplate": "{{auditType}} Audit ist seit {{interval}} überfällig",
      "policyRequires": "Die Lieferantenrichtlinie erfordert, dass dieser Lieferant alle {{frequency}} Monate ab dem Datum des letzten Audits ({{lastAuditDate}}) mit einem {{auditType}} Audit geprüft wird.",
      "supplierPolicyLink": "Lieferantenrichtlinie"
    }
  },
  "createAuditForm": {
    "heading": "Audit-Informationen",
    "fields": {
      "auditName": {
        "label": "Audit-Name*",
        "error": "Bitte Audit-Namen ausfüllen"
      },
      "auditType": {
        "label": "Audit-Typ*",
        "error": "Bitte Audit-Typ ausfüllen"
      },
      "notes": {
        "label": "Notizen"
      },
      "completionDate": {
        "label": "Abschlussdatum",
        "helper": "Das Abschlussdatum bestimmt das nächste geplante Audit dieses Typs basierend auf der Lieferantenrichtlinie.",
        "placeholder": "TT/MM/JJJJ"
      }
    },
    "sections": {
      "auditDocuments": "Audit-Dokumente"
    },
    "errors": {
      "fillRequiredFields": "Bitte Pflichtfelder ausfüllen"
    }
  },
  "documentCard": {
    "buttons": {
      "addDocument": "Dokument hinzufügen",
      "uploadFromComputer": "Vom Computer hochladen",
      "qualioDoc": "Qualio-Dokument",
      "download": "Herunterladen",
      "open": "Öffnen",
      "delete": "Löschen",
      "addDescription": "Beschreibung hinzufügen"
    }
  },
  "qualioDocSelect": {
    "noDocumentFound": "Kein Dokument gefunden mit dem Präfix:",
    "placeholder": "Bitte geben Sie ein gültiges Präfix eines Qualio-Dokuments ein, z. B.: \"POL\""
  },
  "importModal": {
    "title": "Lieferanten importieren",
    "description": "Wenn Sie Lieferantendatensätze als Qualio-Dokumente speichern, können Sie diese in die Lieferantenliste importieren. Geben Sie das Vorlagen-Präfix der Lieferantendatensätze ein.",
    "fields": {
      "templatePrefix": {
        "label": "Vorlagen-Präfix",
        "helper": "Zum Beispiel \"SQF\"",
        "button": "Suchen"
      }
    },
    "messages": {
      "found": "{{count}} Lieferantendatensätze wurden mit dem Präfix {{prefix}} gefunden",
      "notFound": "Es wurden keine Lieferantendatensätze mit dem Präfix {{prefix}} gefunden"
    },
    "buttons": {
      "cancel": "Abbrechen",
      "import": "Importieren"
    }
  },
  "changeControlAlerts": {
    "approvalDeclined": "Freigabe abgelehnt",
    "approvalPreviouslyDeclined": "Freigabe zuvor abgelehnt",
    "declinedMessage": "{{name}} hat die Freigabe dieses Lieferanten am {{date}} aus folgendem Grund abgelehnt: \"{{reason}}\""
  },
  "statusChangeModal": {
    "approveTitle": "Lieferant freigeben",
    "rejectTitle": "Lieferant ablehnen",
    "approveMessage": "Geben Sie Ihr Passwort ein, um diesen Lieferanten freizugeben.",
    "rejectMessage": "Geben Sie Ihr Passwort ein, um diesen Lieferanten abzulehnen.",
    "fields": {
      "email": {
        "label": "E-Mail",
        "error": "Bitte geben Sie eine E-Mail-Adresse ein"
      },
      "password": {
        "label": "Passwort",
        "error": "Bitte geben Sie ein Passwort ein"
      },
      "reason": {
        "label": "Grund für die Ablehnung",
        "error": "Bitte geben Sie einen Grund für die Ablehnung dieses Lieferanten an"
      }
    },
    "errors": {
      "fillRequiredFields": "Bitte Pflichtfelder ausfüllen",
      "somethingWentWrong": "Etwas ist schiefgelaufen",
      "requiredFields": "Bitte Pflichtfelder ausfüllen",
      "generic": "Etwas ist schiefgelaufen",
      "email": "Bitte geben Sie eine E-Mail-Adresse ein",
      "password": "Bitte geben Sie ein Passwort ein",
      "reason": "Bitte geben Sie einen Grund für die Ablehnung dieses Lieferanten an"
    },
    "buttons": {
      "cancel": "Abbrechen",
      "approve": "Freigeben",
      "reject": "Ablehnen"
    }
  },
  "policyConfiguration": {
    "heading": "Richtlinienkonfiguration",
    "tabs": {
      "supplierTypes": "Lieferantentypen",
      "riskLevels": "Risikostufen",
      "documentTypes": "Dokumententypen",
      "auditTypes": "Audit-Typen"
    },
    "template": {
      "title": "Sie haben noch keine Überprüfungstypen definiert",
      "subtitle": "Legen Sie fest, welche Überprüfungstypen in der Richtlinie verwendet werden sollen. Nutzen Sie die vorgeschlagene Vorlage und passen Sie diese an oder erstellen Sie eigene.",
      "useTemplate": "Vorgeschlagene {{name}}-Definitionen verwenden",
      "buttons": {
        "useTemplate": "Diese Vorlage verwenden",
        "createFromScratch": "Neu erstellen"
      },
      "divider": "oder"
    },
    "configurationCard": {
      "placeholders": {
        "name": "Name",
        "addDescription": "Beschreibung hinzufügen"
      }
    },
    "buttons": {
      "addNew": "Neu hinzufügen",
      "cancel": "Abbrechen",
      "saveChanges": "Änderungen speichern"
    },
    "modals": {
      "saveChanges": {
        "title": "Änderungen speichern",
        "message": "Änderungen an den Lieferantentypen wirken sich auf alle bestehenden Lieferanten dieser Typen aus. Bitte überprüfen Sie alle betroffenen Lieferanten und bewerten Sie diese bei Bedarf neu.",
        "buttons": {
          "cancel": "Abbrechen",
          "save": "Änderungen speichern"
        }
      }
    }
  },
  "supplierPolicy": {
    "heading": "Lieferantenrichtlinie",
    "buttons": {
      "configuration": "Konfiguration",
      "edit": "Bearbeiten",
      "export": "Exportieren"
    },
    "tabs": {
      "requiredDocuments": "Erforderliche Dokumente",
      "audits": "Audits"
    },
    "drawer": {
      "title": "Richtlinie bearbeiten",
      "sections": {
        "supplierType": "Lieferantentyp",
        "riskLevel": "Risikostufe",
        "requiredDocuments": "Erforderliche Dokumente",
        "audits": "Audits"
      },
      "descriptions": {
        "requiredDocuments": "Die Richtlinie erfordert diese Dokumente, damit ein Lieferant freigegeben werden kann.",
        "audits": "Diese Audits sind für alle Lieferanten dieses Typs und dieser Risikostufe erforderlich."
      },
      "placeholders": {
        "addDocumentType": "Dokumententyp hinzufügen",
        "addAuditType": "Audit-Typ hinzufügen",
        "dueEvery": "Fällig alle"
      },
      "frequencyOptions": {
        "once": "Einmalig",
        "monthsFromLastAudit": "{{count}} Monat(e) nach dem letzten Audit"
      },
      "noTypesFound": "{{type}}-Typen sind in Ihrer Lieferantenrichtlinie noch nicht definiert oder Sie haben alle verfügbaren Optionen ausgewählt.",
      "warning": "Änderungen an der Lieferantenrichtlinie wirken sich auf alle bestehenden Lieferanten dieses Typs und dieser Risikostufe aus. Überprüfen Sie alle betroffenen Lieferanten und bewerten Sie diese bei Bedarf neu.",
      "buttons": {
        "cancel": "Abbrechen",
        "save": "Speichern"
      }
    },
    "table": {
      "supplierType": "LIEFERANTENTYP",
      "riskLevel": "RISIKOSTUFE"
    }
  },
  "aslExport": {
    "coverPage": {
      "title": "Liste freigegebener Lieferanten (ASL)",
      "generatedBy": "Erstellt von {{userName}}",
      "generatedWith": "Erstellt mit",
      "qmsForLifeSciences": "QMS für Life Sciences",
      "website": "www.qualio.com"
    },
    "listPage": {
      "columns": {
        "supplierName": "Lieferantenname",
        "type": "Typ",
        "riskLevel": "Risikostufe",
        "intendedUse": "Verwendungszweck",
        "lastAudit": "Letztes Audit",
        "auditDue": "Audit fällig"
      }
    }
  },
  "upSellViews": {
    "upgradeAccess": {
      "title": "Upgrade für Zugriff auf Lieferanten",
      "subtitle": "Ihr aktueller Qualio-Plan enthält die neue Lieferanten-Funktion nicht. Kontaktieren Sie Ihren Customer Success Repräsentanten für Informationen zum Upgrade.",
      "button": "Mehr über Lieferanten erfahren"
    },
    "insufficientPermissions": {
      "title": "Möchten Sie an der Lieferkette arbeiten?",
      "subtitle": "Leider haben Sie derzeit keinen Zugriff auf das Lieferanten-Modul. Kontaktieren Sie Ihren Administrator, um Lieferanten einfach zu integrieren, zu verwalten und kontinuierlich zu verbessern.",
      "button": "Produktvideo ansehen"
    },
    "starterView": {
      "title": "Möchten Sie an der Lieferkette arbeiten?",
      "subtitle": "Leider haben Sie derzeit keinen Zugriff auf das Lieferanten-Modul. Kontaktieren Sie unser Support-Team, um Lieferanten einfach zu integrieren, zu verwalten und kontinuierlich zu verbessern.",
      "buttons": {
        "contactSupport": "Qualio Support kontaktieren",
        "watchVideo": "Produktvideo ansehen"
      }
    }
  },
  "emergencyBreak": {
    "title": "Das Lieferanten-Modul wird gewartet",
    "subtitle": "Wir führen derzeit Wartungsarbeiten am Lieferanten-Modul durch. Bitte versuchen Sie es später noch einmal. Kontaktieren Sie uns bei Fragen."
  },
  "notFound": {
    "message": "Sie scheinen sich verlaufen zu haben"
  },
  "privateRoute": {
    "unauthorizedTitle": "Sie haben keine Berechtigung für diesen Zugriff",
    "unauthorizedSubtitle": "Sie müssen als Quality-Benutzer angemeldet sein, um Lieferantenrichtlinien anzuzeigen und zu bearbeiten. Wenn Sie Zugriff benötigen, wenden Sie sich an Ihr Qualitätsteam."
  },
  "navigation": {
    "tabs": {
      "supplier": "Lieferant",
      "policy": "Richtlinie"
    }
  },
  "statuses": {
    "approved": "Freigegeben",
    "pending": "Ausstehend",
    "rejected": "Abgelehnt",
    "draft": "Entwurf",
    "archived": "Archiviert"
  },
  "toastMessages": {
    "supplier": {
      "archived": "Archiviert",
      "archivedDescription": "{{name}} wurde archiviert",
      "archiveFailed": "Fehler",
      "archiveFailedDescription": "Lieferant wurde nicht archiviert",
      "failure": "Fehler",
      "notArchived": "Lieferant nicht archiviert",
      "unArchived": "Dearchiviert",
      "unArchivedDescription": "{{name}} wurde dearchiviert",
      "notUnArchived": "Lieferant wurde nicht dearchiviert",
      "unarchived": "Dearchiviert",
      "unarchivedDescription": "{{name}} wurde dearchiviert",
      "unarchiveFailed": "Fehler",
      "unarchiveFailedDescription": "Lieferant wurde nicht dearchiviert",
      "reverted": "Zurückgesetzt",
      "revertedDescription": "{{name}} wurde auf Entwurf zurückgesetzt",
      "revertedToDraftDescription": "{{name}} wurde auf Entwurf zurückgesetzt",
      "notRevertedToDraft": "Lieferant wurde nicht auf Entwurf zurückgesetzt",
      "revertFailed": "Fehler",
      "revertFailedDescription": "Lieferant wurde nicht auf Entwurf zurückgesetzt",
      "saved": "Gespeichert",
      "savedAsDraft": "{{name}} wurde als Entwurf gespeichert.",
      "savedAsDraftDescription": "{{name}} wurde als Entwurf gespeichert.",
      "notSavedAsDraft": "Lieferant wurde nicht als Entwurf gespeichert",
      "notSentForApproval": "Lieferant wurde nicht zur Freigabe gesendet",
      "sent": "Gesendet",
      "sentForApproval": "{{name}} wurde zur Freigabe gesendet",
      "sentForApprovalDescription": "{{name}} wurde zur Freigabe gesendet",
      "saveFailed": "Fehler",
      "saveFailedDescription": "Lieferant wurde nicht als Entwurf gespeichert.",
      "fileReady": "Datei bereit",
      "fileReadyDescription": "Die Datei ist jetzt bereit zum",
      "download": "Herunterladen",
      "exportFailed": "Fehler",
      "exportFailedDescription": "Lieferant wurde nicht exportiert",
      "notExported": "Lieferant nicht exportiert",
      "revertedToDraft": "{{name}} wurde auf Entwurf zurückgesetzt",
      "revertToDraftFailed": "Lieferant wurde nicht auf Entwurf zurückgesetzt",
      "preparingFile": "Datei wird für den Download vorbereitet",
      "preparingFileDescription": "Wir benachrichtigen Sie, wenn die Datei fertig ist",
      "exportsFailed": "Lieferanten wurden nicht exportiert",
      "suppliersNotExported": "Lieferanten nicht exportiert"
    },
    "audit": {
      "added": "Audit hinzugefügt",
      "creationFailed": "Audit-Erstellung fehlgeschlagen",
      "creationFailedDescription": "Audit konnte nicht mit dem Lieferanten verknüpft werden",
      "updated": "Audit updated",
      "updateFailed": "Audit update failed",
      "updateFailedDescription": "Failed to update the audit",
      "deleted": "Audit gelöscht",
      "deletionFailed": "Audit-Löschung fehlgeschlagen",
      "deletionFailedDescription": "Audit konnte nicht vom Lieferanten gelöscht werden"
    },
    "config": {
      "configuration": "Konfiguration",
      "updated": "{{configType}} wurde aktualisiert",
      "updateFailed": "Konfigurations-Update fehlgeschlagen"
    },
    "policy": {
      "saved": "Richtlinie gespeichert",
      "savedDescription": "Möglicherweise müssen Sie betroffene Lieferanten neu bewerten.",
      "saveFailed": "Fehler",
      "saveFailedDescription": "Ihre Richtlinie konnte nicht gespeichert werden."
    },
    "policyLinks": {
      "fetchFailed": "Beim Abrufen Ihrer erforderlichen Dokumente ist ein Fehler aufgetreten"
    },
    "import": {
      "success": "Import erfolgreich",
      "successDescription": "Lieferanten wurden erfolgreich importiert",
      "failed": "Import fehlgeschlagen",
      "failedDescription": "Lieferanten konnten nicht importiert werden"
    },
    "approval": {
      "completed": "Freigabeaktion abgeschlossen"
    },
    "document": {
      "downloadError": "Fehler",
      "downloadErrorDescription": "Beim Herunterladen dieses Dokuments ist ein Fehler aufgetreten"
    },
    "export": {
      "error": "Fehler",
      "errorDescription": "Keine freigegebenen Lieferanten zum Exportieren vorhanden",
      "policyLinksError": "Richtlinien-Links können nicht abgerufen werden",
      "supplierExportToast": "{{name}} Export",
      "configExportToast": "Export der Lieferantenkonfiguration"
    }
  },
  "common": {
    "buttons": {
      "cancel": "Abbrechen",
      "save": "Speichern",
      "delete": "Löschen",
      "edit": "Bearbeiten",
      "close": "Schließen",
      "review": "Prüfen",
      "ok": "OK",
      "gotIt": "Verstanden"
    },
    "placeholders": {
      "noData": "--"
    },
    "ariaLabels": {
      "deleteDescription": "Beschreibung-löschen",
      "downloadFile": "Datei herunterladen",
      "openQualioDoc": "Qualio-Dokument öffnen",
      "deleteFile": "Datei löschen",
      "deletePolicyRow": "Richtlinien-Zeile löschen",
      "viewRelatedRecords": "Zugehörige Datensätze anzeigen"
    },
    "misc": {
      "auditType": "Audit-Typ:",
      "name": "Name:",
      "type": "Typ:"
    }
  }
}
